var DealEventPipe;

if (window.BuyMore == null) {
  window.BuyMore = {};
}

DealEventPipe = require('../../deal/frontend/event_pipe');

BuyMore.disableQuantityPicker = function($quantityPicker, removeHtml) {
  if (removeHtml == null) {
    removeHtml = false;
  }
  $quantityPicker.attr('disabled', true);
  if (removeHtml) {
    $quantityPicker.empty();
    return $quantityPicker.attr('data-current-option', '');
  }
};

BuyMore.enableQuantityPicker = function($quantityPicker) {
  $quantityPicker.attr('disabled', false);
  return BuyMore.updateBuyButtonUrl({
    currentTarget: $quantityPicker
  });
};

BuyMore.updateQuantityPickerHtml = function(arg) {
  var currentOption, currentTarget, data, optionId;
  currentTarget = arg.currentTarget, data = arg.data;
  currentOption = data.$quantityPicker.attr('data-current-option');
  optionId = data.optionId || $(currentTarget).attr('data-option');
  if (currentOption === optionId) {
    return;
  }
  data.$quantityPicker.empty().append(data.buyMore[optionId].selectHtml);
  data.$quantityPicker.attr('data-current-option', optionId);
  if (data.buyMore[optionId].enableSelection) {
    return BuyMore.enableQuantityPicker(data.$quantityPicker);
  } else {
    return BuyMore.disableQuantityPicker(data.$quantityPicker);
  }
};

BuyMore.updateBuyButtonUrl = function(arg) {
  var $buyButton, currentTarget, newHref, newValue, oldHref;
  currentTarget = arg.currentTarget;
  $buyButton = $('.buy-button');
  newValue = $(currentTarget).val();
  oldHref = $buyButton.attr('href');
  newHref = oldHref.match(/quantity=[0-9]+[^&]?/) ? $buyButton.attr('href').replace(/quantity=[0-9]+[^&]?/, "quantity=" + newValue) : oldHref + ("&quantity=" + newValue);
  return $buyButton.attr('href', newHref);
};

BuyMore.updateAllQuantityPickers = function(arg) {
  var currentTarget, data, newValue;
  currentTarget = arg.currentTarget, data = arg.data;
  newValue = $(currentTarget).val();
  return data.$quantityPicker.val(newValue);
};

BuyMore.init = function(payload, done) {
  var $quantityPicker, $selectedOption, eventData;
  if (payload.buyMore == null) {
    return done();
  }
  $quantityPicker = $('.quantity-picker select');
  eventData = {
    buyMore: payload.buyMore,
    $quantityPicker: $quantityPicker
  };
  if ($selectedOption = $('.multi-option-breakout input:checked')[0]) {
    BuyMore.updateQuantityPickerHtml({
      currentTarget: $selectedOption,
      data: eventData
    });
  }
  $quantityPicker.on("change", eventData, BuyMore.updateBuyButtonUrl);
  if ($quantityPicker.length > 1) {
    $quantityPicker.on("change", eventData, BuyMore.updateAllQuantityPickers);
  }
  DealEventPipe.on("buyMoreUpdate", function(data, disablePicker) {
    if (data == null) {
      data = {};
    }
    if (disablePicker == null) {
      disablePicker = false;
    }
    if (disablePicker) {
      return BuyMore.disableQuantityPicker($quantityPicker, true);
    } else {
      return BuyMore.updateQuantityPickerHtml({
        data: _.extend({}, eventData, {
          optionId: data.id
        })
      });
    }
  });
  return done();
};

module.exports = BuyMore;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9idXlfbW9yZS9mcm9udGVuZC9tYWluLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2FrZXNoYXJpL25hcGlzdHJhbm8vYnVpbGQvMTQ5NTY2MDg5ODI0OS00Mzk2L3Byb2R1Y3Rpb24tMjAxNy4wNS4yNF8yMS4xOS9kZWFsL21vZHVsZXMvYnV5X21vcmUvZnJvbnRlbmQvbWFpbi5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7O0VBQUEsTUFBTSxDQUFDLFVBQVc7OztBQUVsQixhQUFBLEdBQWdCLE9BQUEsQ0FBUSxnQ0FBUjs7QUFFaEIsT0FBTyxDQUFDLHFCQUFSLEdBQWdDLFNBQUMsZUFBRCxFQUFrQixVQUFsQjs7SUFBa0IsYUFBYTs7RUFDN0QsZUFBZSxDQUFDLElBQWhCLENBQXFCLFVBQXJCLEVBQWlDLElBQWpDO0VBRUEsSUFBRyxVQUFIO0lBQ0UsZUFBZSxDQUFDLEtBQWhCLENBQUE7V0FDQSxlQUFlLENBQUMsSUFBaEIsQ0FBcUIscUJBQXJCLEVBQTRDLEVBQTVDLEVBRkY7O0FBSDhCOztBQU9oQyxPQUFPLENBQUMsb0JBQVIsR0FBK0IsU0FBQyxlQUFEO0VBQzdCLGVBQWUsQ0FBQyxJQUFoQixDQUFxQixVQUFyQixFQUFpQyxLQUFqQztTQUNBLE9BQU8sQ0FBQyxrQkFBUixDQUEyQjtJQUFDLGFBQUEsRUFBZSxlQUFoQjtHQUEzQjtBQUY2Qjs7QUFJL0IsT0FBTyxDQUFDLHdCQUFSLEdBQW1DLFNBQUMsR0FBRDtBQUNqQyxNQUFBO0VBRG1DLG1DQUFlO0VBQ2xELGFBQUEsR0FBZ0IsSUFBSSxDQUFDLGVBQWUsQ0FBQyxJQUFyQixDQUEwQixxQkFBMUI7RUFDaEIsUUFBQSxHQUFXLElBQUksQ0FBQyxRQUFMLElBQWlCLENBQUEsQ0FBRSxhQUFGLENBQWdCLENBQUMsSUFBakIsQ0FBc0IsYUFBdEI7RUFFNUIsSUFBVSxhQUFBLEtBQWlCLFFBQTNCO0FBQUEsV0FBQTs7RUFFQSxJQUFJLENBQUMsZUFBZSxDQUFDLEtBQXJCLENBQUEsQ0FBNEIsQ0FBQyxNQUE3QixDQUFvQyxJQUFJLENBQUMsT0FBUSxDQUFBLFFBQUEsQ0FBUyxDQUFDLFVBQTNEO0VBQ0EsSUFBSSxDQUFDLGVBQWUsQ0FBQyxJQUFyQixDQUEwQixxQkFBMUIsRUFBZ0QsUUFBaEQ7RUFFQSxJQUFHLElBQUksQ0FBQyxPQUFRLENBQUEsUUFBQSxDQUFTLENBQUMsZUFBMUI7V0FDRSxPQUFPLENBQUMsb0JBQVIsQ0FBNkIsSUFBSSxDQUFDLGVBQWxDLEVBREY7R0FBQSxNQUFBO1dBR0UsT0FBTyxDQUFDLHFCQUFSLENBQThCLElBQUksQ0FBQyxlQUFuQyxFQUhGOztBQVRpQzs7QUFjbkMsT0FBTyxDQUFDLGtCQUFSLEdBQTZCLFNBQUMsR0FBRDtBQUMzQixNQUFBO0VBRDZCLGdCQUFEO0VBQzVCLFVBQUEsR0FBYSxDQUFBLENBQUUsYUFBRjtFQUNiLFFBQUEsR0FBVyxDQUFBLENBQUUsYUFBRixDQUFnQixDQUFDLEdBQWpCLENBQUE7RUFDWCxPQUFBLEdBQVUsVUFBVSxDQUFDLElBQVgsQ0FBZ0IsTUFBaEI7RUFFVixPQUFBLEdBQWEsT0FBTyxDQUFDLEtBQVIsQ0FBYyxzQkFBZCxDQUFILEdBQ1IsVUFBVSxDQUFDLElBQVgsQ0FBZ0IsTUFBaEIsQ0FBdUIsQ0FBQyxPQUF4QixDQUFnQyxzQkFBaEMsRUFBd0QsV0FBQSxHQUFZLFFBQXBFLENBRFEsR0FHUixPQUFBLEdBQVUsQ0FBQSxZQUFBLEdBQWEsUUFBYjtTQUVaLFVBQVUsQ0FBQyxJQUFYLENBQWdCLE1BQWhCLEVBQXdCLE9BQXhCO0FBVjJCOztBQVk3QixPQUFPLENBQUMsd0JBQVIsR0FBbUMsU0FBQyxHQUFEO0FBQ2pDLE1BQUE7RUFEbUMsbUNBQWU7RUFDbEQsUUFBQSxHQUFXLENBQUEsQ0FBRSxhQUFGLENBQWdCLENBQUMsR0FBakIsQ0FBQTtTQUNYLElBQUksQ0FBQyxlQUFlLENBQUMsR0FBckIsQ0FBeUIsUUFBekI7QUFGaUM7O0FBSW5DLE9BQU8sQ0FBQyxJQUFSLEdBQWUsU0FBQyxPQUFELEVBQVUsSUFBVjtBQUNiLE1BQUE7RUFBQSxJQUFxQix1QkFBckI7QUFBQSxXQUFPLElBQUEsQ0FBQSxFQUFQOztFQUNBLGVBQUEsR0FBa0IsQ0FBQSxDQUFFLHlCQUFGO0VBRWxCLFNBQUEsR0FDRTtJQUFBLE9BQUEsRUFBUyxPQUFPLENBQUMsT0FBakI7SUFDQSxlQUFBLEVBQWlCLGVBRGpCOztFQUdGLElBQUcsZUFBQSxHQUFrQixDQUFBLENBQUUsc0NBQUYsQ0FBMEMsQ0FBQSxDQUFBLENBQS9EO0lBQ0UsT0FBTyxDQUFDLHdCQUFSLENBQWlDO01BQUMsYUFBQSxFQUFlLGVBQWhCO01BQWlDLElBQUEsRUFBTSxTQUF2QztLQUFqQyxFQURGOztFQUdBLGVBQWUsQ0FBQyxFQUFoQixDQUFtQixRQUFuQixFQUE2QixTQUE3QixFQUF3QyxPQUFPLENBQUMsa0JBQWhEO0VBRUEsSUFBRyxlQUFlLENBQUMsTUFBaEIsR0FBeUIsQ0FBNUI7SUFDRSxlQUFlLENBQUMsRUFBaEIsQ0FBbUIsUUFBbkIsRUFBNkIsU0FBN0IsRUFBd0MsT0FBTyxDQUFDLHdCQUFoRCxFQURGOztFQUdBLGFBQWEsQ0FBQyxFQUFkLENBQWlCLGVBQWpCLEVBQWtDLFNBQUMsSUFBRCxFQUFZLGFBQVo7O01BQUMsT0FBTzs7O01BQUksZ0JBQWdCOztJQUM1RCxJQUFHLGFBQUg7YUFDRSxPQUFPLENBQUMscUJBQVIsQ0FBOEIsZUFBOUIsRUFBK0MsSUFBL0MsRUFERjtLQUFBLE1BQUE7YUFHRSxPQUFPLENBQUMsd0JBQVIsQ0FBaUM7UUFBQSxJQUFBLEVBQU0sQ0FBQyxDQUFDLE1BQUYsQ0FBUyxFQUFULEVBQWEsU0FBYixFQUF3QjtVQUFBLFFBQUEsRUFBVSxJQUFJLENBQUMsRUFBZjtTQUF4QixDQUFOO09BQWpDLEVBSEY7O0VBRGdDLENBQWxDO1NBTUEsSUFBQSxDQUFBO0FBdEJhOztBQXdCZixNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
